export default __webpack_public_path__ + "static/media/me1.449ec848.png";